module.exports = __webpack_public_path__ + "img/videoct.2a8698e5.png";